import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';

import setAppVersion from './version';

import App from './components/App';

if (!process.env.IS_PRODUCTION) {
  configure({
    enforceActions: 'always',
    isolateGlobalState: true,
  });
} else {
  configure({
    isolateGlobalState: true,
  });
}

const startApp = async () => {
  ReactDOM.render(<App />, document.getElementById('rating'));
};

setAppVersion();
startApp();
